import { produce } from 'immer';
import { PropsWithChildren, useMemo } from 'react';
import { create } from 'zustand';
import { CSVContext, CSVService } from './useCSVService';


interface CSVProviderProps {}

export function CSVProvider({ children }: PropsWithChildren<CSVProviderProps>) {
  const store = useMemo(
    () =>
      create<CSVService>(set => ({
        status: 'Idle', // Idle | Parsing | Validating | Done
        progress: 0,

        maps: {},
        addMapAssociation: (mapId: string, id: string, value: string) => {
          set(state =>
            produce(state, draft => {
              if (!draft.maps[mapId]) draft.maps[mapId] = {};
              draft.maps[mapId][id] = value;
            })
          );
        },
        removeMapAssociation: (mapId: string, id: string) => {
          set(state =>
            produce(state, draft => {
              if (!draft.maps[mapId]) draft.maps[mapId] = {};
              delete draft.maps[mapId][id];
            })
          );
        },

        onComplete: result => {
          set({ status: 'Done', result });
        }
      })),
    []
  );

  return <CSVContext.Provider value={store}>{children}</CSVContext.Provider>;
}

